import type { SearchFormGoal } from '@travelata-libs/travelata-frontend';
import marketingClient from '@/js/common/Domain/Service/marketingClient';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import AbstractTrackingService from '@ve/services/analytics/yandexAnalytics/abstractTrackingService';

interface HotelPageAppConfig {
    hotelInfo?: { id?: number };
}

const trackingService = new AbstractTrackingService();

function sendSearchFormGoal(goal: SearchFormGoal): void {
    const hotelId = (window as unknown as { appConfig?: HotelPageAppConfig }).appConfig?.hotelInfo?.id;
    trackingService.setTrackingGoal(goal.name, 'click', {
        ...goal.params,
        client_uuid: marketingClient?.getClientUuid() ?? '',
        sid: String(searchSessionService.getSearchId() || ''),
        hsid: String(searchSessionService.getHotelSearchId() || ''),
        ...(hotelId ? { hotel_id: String(hotelId) } : {}),
    });
}

// Поиск на этих страницах ведёт монолит: id поиска и отеля знает только он, поэтому цели формы либы отправляем отсюда.
// Цель «Найти» либа шлёт до события search, а новый sid/hsid монолит выдаёт синхронно в formSubmit — отправка
// после текущего обработчика уводит цель уже с id нового поиска.
export function trackSearchFormGoal(goal: SearchFormGoal): void {
    queueMicrotask(() => sendSearchFormGoal(goal));
}
